'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _findComponent = require('@brandwatch/axiom-utils/dist/findComponent');

var _findComponent2 = _interopRequireDefault(_findComponent);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Base = require('../Base/Base');

var _Base2 = _interopRequireDefault(_Base);

var _Validate = require('../Validation/Validate');

var _Validate2 = _interopRequireDefault(_Validate);

var _TextInputIcon = require('./TextInputIcon');

var _TextInputIcon2 = _interopRequireDefault(_TextInputIcon);

var _TextInputButton = require('./TextInputButton');

var _ProgressInfinite = require('../Progress/ProgressInfinite');

var _ProgressInfinite2 = _interopRequireDefault(_ProgressInfinite);

var _InputWrapper = require('./InputWrapper');

var _InputWrapper2 = _interopRequireDefault(_InputWrapper);

require('./TextInput.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextInput = function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput(props) {
    _classCallCheck(this, TextInput);

    var _this = _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props));

    _this.state = { hasFocus: false };
    return _this;
  }

  _createClass(TextInput, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        size: this.props.size
      };
    }
  }, {
    key: 'handleOnBlur',
    value: function handleOnBlur() {
      var _props$onBlur = this.props.onBlur,
          onBlur = _props$onBlur === undefined ? function () {} : _props$onBlur;

      this.setState({ hasFocus: false });
      onBlur.apply(undefined, arguments);
    }
  }, {
    key: 'handleOnFocus',
    value: function handleOnFocus() {
      var _props$onFocus = this.props.onFocus,
          onFocus = _props$onFocus === undefined ? function () {} : _props$onFocus;

      this.setState({ hasFocus: true });
      onFocus.apply(undefined, arguments);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          disabled = _props.disabled,
          error = _props.error,
          valid = _props.valid,
          invalid = _props.invalid,
          isInProgress = _props.isInProgress,
          isTarget = _props.isTarget,
          label = _props.label,
          onClear = _props.onClear,
          patterns = _props.patterns,
          required = _props.required,
          size = _props.size,
          space = _props.space,
          style = _props.style,
          type = _props.type,
          usageHint = _props.usageHint,
          usageHintPosition = _props.usageHintPosition,
          value = _props.value,
          inputRef = _props.inputRef,
          inlineLabel = _props.inlineLabel,
          rest = _objectWithoutProperties(_props, ['children', 'disabled', 'error', 'valid', 'invalid', 'isInProgress', 'isTarget', 'label', 'onClear', 'patterns', 'required', 'size', 'space', 'style', 'type', 'usageHint', 'usageHintPosition', 'value', 'inputRef', 'inlineLabel']);

      var hasFocus = this.state.hasFocus;

      var icon = (0, _findComponent2.default)(children, _TextInputIcon.TextInputIconRef);
      var button = (0, _findComponent2.default)(children, _TextInputButton.TextInputButtonRef);
      var showOnClear = onClear && value && !isInProgress;
      var showIcon = icon && (!isInProgress || icon.props.align === 'left');

      return _react2.default.createElement(
        _Validate2.default,
        {
          error: error,
          patterns: patterns,
          required: required,
          value: value },
        function (isValid) {
          return _react2.default.createElement(
            _Base2.default,
            { className: 'ax-input__container', space: space },
            _react2.default.createElement(
              _InputWrapper2.default,
              {
                disabled: disabled,
                hasFocus: hasFocus,
                inlineLabel: inlineLabel,
                invalid: invalid,
                isTarget: isTarget,
                isValid: isValid,
                label: label,
                size: size,
                space: space,
                style: style,
                usageHint: usageHint,
                usageHintPosition: usageHintPosition,
                valid: valid },
              showOnClear && _react2.default.createElement(_TextInputIcon2.default, {
                align: 'right',
                name: 'cross',
                onClick: onClear }),
              showIcon && icon,
              _react2.default.createElement(_Base2.default, _extends({}, rest, {
                Component: 'input',
                baseRef: inputRef,
                className: 'ax-input',
                disabled: disabled,
                onBlur: _this2.handleOnBlur.bind(_this2),
                onFocus: _this2.handleOnFocus.bind(_this2),
                type: type,
                value: value })),
              isInProgress && _react2.default.createElement(
                'span',
                { className: 'ax-input__progress' },
                _react2.default.createElement(_ProgressInfinite2.default, { sizeRem: '1rem' })
              )
            ),
            button
          );
        }
      );
    }
  }]);

  return TextInput;
}(_react.Component);

TextInput.propTypes = {
  /** Optional TextInputIcon or TextInputButton all other children are ignored */
  children: _propTypes2.default.node,
  /** Disables interactions and applies styling */
  disabled: _propTypes2.default.bool,
  /** See Validate[error] */
  error: _propTypes2.default.func,
  /** Display label inline */
  inlineLabel: _propTypes2.default.bool,
  /** Pass this prop to get ref to the Text Component instance. */
  inputRef: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  /** Applies styling to indicate the users input was invalid */
  invalid: _propTypes2.default.bool,
  /** Adds a progress indicator the the right of the text input */
  isInProgress: _propTypes2.default.bool,
  /** Changes the icon to pointer */
  isTarget: _propTypes2.default.bool,
  /** Descriptive label that is placed with the input field */
  label: _propTypes2.default.string,
  /** Handler for when the input field is blurred */
  onBlur: _propTypes2.default.func,
  /** Handler for changing the input field */
  onChange: _propTypes2.default.func,
  /** Handler for requesting to clear the input field */
  onClear: _propTypes2.default.func,
  /** Handler for when the input field is focused */
  onFocus: _propTypes2.default.func,
  /** See Validate[patterns] */
  patterns: _propTypes2.default.array,
  /**
   * Descriptive placeholder text that is displayed in the input field
   * when there is no value
   */
  placeholder: _propTypes2.default.string,
  /** See Validate[required] */
  required: _propTypes2.default.bool,
  /** Size of the input field */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  /** SKIP */
  space: _propTypes2.default.string,
  /** Visual style variations of the input field */
  style: _propTypes2.default.oneOf(['overlay']),
  /** Type of the input field */
  type: _propTypes2.default.oneOf(['password', 'text', 'number']),
  /**
   * Specifies text to be used in the form element's usage hint that is
   * displayed in a tooltip coming off a question mark in the top right
   */
  usageHint: _propTypes2.default.node,
  /** direction of usagehint popup */
  usageHintPosition: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']),
  /** Applies styling to indicate the users input was valid */
  valid: _propTypes2.default.bool,
  /** Value of the input field */
  value: _propTypes2.default.string
};
TextInput.childContextTypes = {
  size: _propTypes2.default.string
};
TextInput.defaultProps = {
  size: 'medium',
  space: 'x4',
  type: 'text',
  inlineLabel: false
};
exports.default = TextInput;